<header
  aria-label="Sub Header"
  role="subHeader"
>
<app-sidenav class="sidenav position-fixed start-0 h-100 zIndex" />
  <div
    class="sub-header d-flex align-items-center px-3 py-1 position-fixed z-3"
    [ngClass]="{ 'sub-header-history': historyMode }"
  >
    <div class="col-md-5 ps-4 ps-xl-0 ps-lg-5 mt-1">
      <h1 class="text-body fs-6 m-0">
        {{ pageTitle || '' }}
      </h1>
    </div>

    <div class="col-md-7 d-flex ms-auto justify-content-end">
      <button
        class="ricon btn p-0 d-md-none history-view-btn"
        *ngIf="showHistoryToggle"
        [ngbPopover]="popoverHistoryContent"
        triggers="click"
        placement="bottom"
        container="body"
        popoverClass="history-popover"
        (shown)="onPopoverOpened()"
      >
        <i class="bi bi-three-dots-vertical"></i>
      </button>

      <ul class="nav gap-3 d-none d-md-flex align-items-center">
        <ng-container *ngIf="showPdfIcon">
          <div
            class="d-flex align-items-center cursor-pointer px-2 border-start"
            tabindex="0"
            role="button"
            (click)="pdfDownload()"
            (keydown.enter)="pdfDownload()"
            (keydown.space)="pdfDownload()"
            aria-label="Download PDF"
          >
            <nr-icon
              [name]="icons.DOWNLOAD_PDF_ICON"
              sizeClass="icon-size-20"
              iconId="downloadPdf"
            ></nr-icon>
            <label
              for="downloadpdf"
              id="downloadpdf"
              class="cursor-pointer text-primary"
            >
              PDF
            </label>
          </div>
        </ng-container>

        <ng-container *ngIf="showSubscribeIcon">
          <li
            class="d-flex align-items-center cursor-pointer px-2"
            tabindex="0"
            (click)="onSubscribeClick()"
            (keydown.enter)="onSubscribeClick()"
            (keydown.space)="onSubscribeClick()"
            role="button"
            [attr.aria-label]="isSubscribedId ? 'Unsubscribe' : 'Subscribe'"
          >
            <nr-icon
              *ngIf="!isSubscribedId"
              class="mt-2"
              [name]="icons.SUBSCRIBE_ICON"
              sizeClass="icon-size-24"
              iconId="subscribe"
            ></nr-icon>
            <nr-icon
              *ngIf="isSubscribedId"
              [name]="icons.UNSUBSCRIBE_ICON"
              sizeClass="icon-size-24"
              iconId="unsubscribe"
            ></nr-icon>
            <label
              for="subscribe"
              id="subscribeLabel"
              class="cursor-pointer text-primary"
            >
              {{ isSubscribedId ? 'Unsubscribe' : 'Subscribe' }}
            </label>
          </li>
        </ng-container>

        <ng-container *ngIf="showHistoryToggle">
          <li class="d-flex align-items-center gap-2 cursor-pointer px-2 border-start">
            <label
              for="history"
              class="text-primary"
            >
              History
            </label>
            <nr-toggle-switch
              class="small-toggle mr-2"
              [formControl]="formControl"
              (toggleChange)="toggleClick()"
            ></nr-toggle-switch>
          </li>
        </ng-container>
      </ul>
      <div
        *ngIf="showRagIcon"
        #triggerRef
        tabindex="0"
        role="tooltip"
        aria-label="Threshold Info"
        (mouseenter)="onInfoIconTrigger($event)"
        (mouseleave)="onInfoIconClose()"
        (focus)="onInfoIconTrigger($event)"
        (blur)="onInfoIconClose()"
        (click)="onInfoIconToggle()"
        class="d-flex align-items-center ps-md-3 border-start me-2 cursor-pointer"
      >
        <svg
          class="icon-size-24"
          role="img"
          title="ThresholdIcon"
        >
          <use xlink:href="/assets/icons/svg-sprite.svg#threshold-info-icon" />
        </svg>
      </div>

      <div
        *ngIf="showAudioIcon"
        class="d-flex align-items-center ps-md-3 cursor-pointer"
        tabindex="0"
        role="button"
        (click)="toggleAudioAlerts()"
        tooltipPosition="left"
        [pTooltip]="audioTooltip"
        tooltipEvent="'focus'"
        [appendTo]="'body'"
      >
        <span *ngIf="isSubscribedToAudioAlerts && showAudioIcon">
          <nr-icon
            [name]="icons.SOUND_ON"
            sizeClass="icon-size-20"
          ></nr-icon>
        </span>
        <span *ngIf="!isSubscribedToAudioAlerts && showAudioIcon">
          <nr-icon
            [name]="icons.SOUND_OFF"
            sizeClass="icon-size-20"
          ></nr-icon>
        </span>
      </div>

      <ng-template #popoverHistoryContent>
        <ul class="nav gap-3 flex-column align-items-start popover-focus-root">
          <ng-container *ngIf="showHistoryToggle">
            <li class="d-flex align-items-center gap-2 cursor-pointer px-2 border-start">
              <label for="history text-primary">History</label>
              <nr-toggle-switch
                class="small-toggle mr-2"
                [label]="'History'"
                [formControl]="formControl"
                (toggleChange)="toggleClick()"
              ></nr-toggle-switch>
            </li>
          </ng-container>

          <ng-container *ngIf="showPdfIcon">
            <li
              class="d-flex align-items-center cursor-pointer px-2 border-start"
              tabindex="0"
              (click)="pdfDownload()"
              (keydown.enter)="pdfDownload()"
              (keydown.space)="pdfDownload()"
            >
              <nr-icon
                [name]="icons.PDF_DOWNLOAD"
                sizeClass="icon-size-24"
                iconId="downloadPdf"
              ></nr-icon>
              <label
                for="downloadpdf"
                id="downloadpdf"
                class="cursor-pointer"
              >
                PDF
              </label>
            </li>
          </ng-container>

          <ng-container *ngIf="showSubscribeIcon">
            <li
              class="d-flex align-items-center cursor-pointer px-2"
              (click)="onSubscribeClick()"
              (keydown.enter)="onSubscribeClick()"
              (keydown.space)="onSubscribeClick()"
              tabindex="0"
            >
              <nr-icon
                [name]="icons.SUBSCRIBE_ICON"
                sizeClass="icon-size-24"
                iconId="subscribe"
              ></nr-icon>
              <label
                for="subscribe"
                id="subscribeLabel"
              >
                {{ isSubscribedId ? 'Unsubscribe' : 'Subscribe' }}
              </label>
            </li>
          </ng-container>
        </ul>
      </ng-template>

      <p-popover
        #pop
        styleClass="popover-threshold-info"
        appendTo="body"
        position="bottom"
      >
        <ng-container *ngIf="bus.popover$ | async as p">
          <ng-container
            *ngIf="p.template"
            [ngTemplateOutlet]="p.template"
            [ngTemplateOutletContext]="p.context"
          ></ng-container>
        </ng-container>
      </p-popover>
    </div>
  </div>
</header>
